module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_39.da937e9b.png";